/**
 * A *mirror* annotation is a span annotation that duplicates a canonical
 * trace-level (run) annotation onto the trace's root span for display. It is
 * tagged with `metadata.mirror_of === "trace_annotation"` and must be hidden
 * wherever the canonical run-level annotation is shown, so the same verdict is
 * not rendered or counted twice.
 */
export const isMirrorAnnotation = (annotation: {
  metadata?: Record<string, unknown> | null;
}): boolean => {
  const metadata = annotation.metadata;
  return (
    metadata != null &&
    typeof metadata === "object" &&
    (metadata as { mirror_of?: unknown }).mirror_of === "trace_annotation"
  );
};
